import loadable from '@loadable/component';

export const BuyCreditsLinksLoadable = loadable(
  () => import('./BuyCreditsLinks'),
  { resolveComponent: (module) => module.BuyCreditsLinks },
);
